import React from 'react'
import Form from 'react-bootstrap/Form'
import { isNull, isPresent } from 'lodash'
import Icon from 'UI/FontAwesomeIcon'
import Spinner from 'react-bootstrap/Spinner';

const useColumns = ({ toggleAlertingEnabled, setAssetToRemove }) => {
  const monitoringTypeColumn = {
    Header: 'Monitoring Type',
    accessor: 'logicmonitorMonitoringType.monitoringType',
  }

  const logicmonitorDeviceIdColumn = {
    Header: 'Logicmonitor Device ID',
    accessor: 'logicmonitorDeviceId'
  }

  const credentialKeySuffixColumn = {
    Header: 'Credential Key Suffix',
    accessor: 'credentialKeySuffix'
  }

  const monitoringEnabledColumn = {
    Header: 'Monitoring Enabled ',
    accessor: 'monitoringEnabled',
    Cell: row => row.original.monitoringEnabled ? 'TRUE' : 'FALSE'
  }

  const alertingColumn = {
    Header: 'Alerting',
    width: 200,
    filterable: false,
    Cell: ({ original: { id, toggleLoading, alertingEnabled } }) => (
      <div className="items-center cursor-pointer inline-flex pl-20">
        <Form.Check 
          type="switch"
          id="custom-switch"
          checked={alertingEnabled}
          onClick={() => toggleAlertingEnabled(id)}
          className="text-2xl"
          disabled={toggleLoading}
        />

        {toggleLoading && (
          <Spinner
            animation="border"
            className="mt-1"
            style={{ marginLeft: '-39px' }}
            size="sm"
            variant="primary"
          />
        )}
      </div>
    )
  }

  const deletedAtColumn = {
    Header: 'Deleted At',
    accessor: 'deletedAt',
    width: 200,
    Cell: row => {
      if (isNull(row.original.deletedAt) || isPresent(row.original.removedFromMonitoring)) return null
      const date = new Date(row.original.deletedAt).toISOString().split("T")[0]

      return (
        <div className="flex items-center justify-center h-full">
          <span className="mr-2">{date}</span>
          <Icon
            className="text-xl text-red-600 cursor-pointer duration-300 hover:text-red-800"
            onClick={() => setAssetToRemove(row.original)}
            icon="trash"
            title="Remove from Logicmonitor"
          />
        </div>
      )
    }
  }

  return [
    monitoringTypeColumn,
    logicmonitorDeviceIdColumn,
    credentialKeySuffixColumn,
    monitoringEnabledColumn,
    alertingColumn,
    deletedAtColumn
  ]
}

export default useColumns
